import HotelCardPenalizedFilters from './HotelCardPenalizedFilters';

export default HotelCardPenalizedFilters;
